const strings = {
  labels: {
    body: 'Do you want to call this number?',
    primaryText: 'Call',
    secondaryText: 'Cancel',
    toPrefix: 'Call',
    fromTitle: 'Calling From',
    callerIdTitle: 'Your Caller ID Displays As',
  },
} as const;

export default strings;
